var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "breadcrumb-content", attrs: { id: "forms-page" } },
    [
      _c("SidebarChild", {
        attrs: {
          items: _vm.menuItems,
          "selected-item": _vm.type,
          focusActive: true,
          className: "forms-menu",
        },
        on: { selected: _vm.navigateTo },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.type === "form"
            ? _c("CreateForms", { attrs: { formId: _vm.$route.params.formId } })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "list" ? _c("FormList") : _vm._e(),
          _vm._v(" "),
          _vm.type === "form-automations"
            ? _c("AutomationList", { attrs: { type: "event", module: "form" } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }